import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { FormConfig } from "@evergiving/common/dist/es2015/form";
import { initialStateFromFormConfig } from "@/lib/redux/store";
import { RootState } from "@/lib/redux/types";

export function useNavigationWarning(formConfig: FormConfig) {
  const expectedState = initialStateFromFormConfig(formConfig);
  const unchanged = useSelector((state: RootState) =>
    (Object.keys(expectedState) as Array<keyof typeof expectedState>).every(
      (key) => state[key] === expectedState[key]
    )
  );

  const handler = useCallback(
    (event: BeforeUnloadEvent) => {
      if (!unchanged) {
        event.preventDefault();
        event.returnValue = ""; // Chrome requires returnValue to be set
      }
    },
    [unchanged]
  );
  useEffect(() => {
    if (process.env.DIGITAL_FORM_DEBUG_IGNORE_NAV !== undefined) {
      return () => {};
    }

    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, [handler]);
}
